import react, { useState, useEffect } from "react";
import "../../../../assets/css/custom.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { API_URL, getApiConfig, getUserRoleId, token } from "../../Config/apiConfig.js";
import {
  Card,
  Row,
  CardBody,
  Col,
  CardFooter,
  CardHeader,
  Button,
  Input,
  // Row,
} from "reactstrap";
import ReactTable from "react-table-v6";
import AlertMailSetup from "views/composant/Admin/AlertMailSetup.js";
// import {
//   OLD_API_URL,
//   oldGetApiConfig,
//   getOldMultipartConfig,
//   oldGetUserRoleId,
//   oldGetUserId,
// } from "views/composant/Config/oldApiConfig";
import axios from "axios";
import ReactTablesUsed from "views/tables/ReactTablesUsed";
import "../../../../assets/css/table.css";
import customFilterMethod from "helpers/customFilterMethod.js";
export default function Reglages() {
  const [data, setData] = useState();
  const [email, setEmail] = useState(""); 
  const nav = useNavigate();
  const params = useParams();

  const localization = {
    previousText: "Précédent",
    nextText: "Suivant",
    pageText: "Page",
    ofText: "sur",
    rowsText: "lignes",
  };
  
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      nav("/login");
    }
  }, [nav]);

  useEffect(() => {
    axios
      .get(API_URL + `uniqueCapteurs`, getApiConfig())
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.log(error, "error in getting capteur data");
      });
  }, []);

  const handleSave = () => {
    const token = localStorage.getItem("token"); // Récupérer le token d'authentification

    axios
      .post(
        `${API_URL}updateEmail`, // Modifier l'ID de l'utilisateur si nécessaire
        {
          email: email, // L'email à mettre à jour
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "User-Agent": "insomnia/9.3.3",
          },
        }
      )
      .then((response) => {
        console.log("Email mis à jour avec succès :", response.data);
      })
      .catch((error) => {
        console.error("Erreur lors de la mise à jour de l'email :", error);
      });
  };

  // Colonnes pour l'affichage des capteurs uniques
  const capteursColumns = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'ID Capteur', accessor: 'id_capteur' },
    { Header: 'Position', accessor: 'position' },
    { Header: 'Position Trame', accessor: 'position_trame' },
    { Header: 'Label', accessor: 'label' },
    { Header: 'Unité', accessor: 'unite' },
    { Header: 'Type', accessor: 'type' },
    { Header: 'Date', accessor: 'date' },
    { Header: 'État', accessor: 'state', Cell: ({ value }) => value === 1 ? 'Actif' : 'Inactif' },
  ];

  return (
    <>
      <div className="main-box">
        {/* <Sidebar /> */}
        <div className="content-wrapper-custom">
          <Col>
            <Row className="CenterAll">
              <Card>
                
                <CardBody>
                  <CardHeader>
                    <h4>E-mail du compte administrateur</h4>
 <Row>
                      <Input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} // Capture la modification de l'input
                        placeholder="Saisir un email"
                        />
                        <Button color="primary" onClick={handleSave}>
                        Save
                        </Button>
                      </Row>
                      </CardHeader>

                    </CardBody>
                    </Card>
                    <Card className="mt-5">
                      <CardBody>
                        <AlertMailSetup />
                      </CardBody>
                    </Card>
                  </Row>
                  <ReactTable
                                        filterable
                                        value={data?.id}
                                        data={data}
                                        defaultFilterMethod={customFilterMethod}
                                        columns={capteursColumns}
                                        defaultPageSize={10}
                                        previousText={localization.previousText}
                                        nextText={localization.nextText}
                                        pageText={localization.pageText}
                                        ofText={localization.ofText}
                                        rowsText={localization.rowsText}
                  />
                  <Row className="CenterAll" style={{ marginBottom: 32 }}>
                    <div className="containertitle add-Bottom">
                    <h2 className="titlePage">VERSIONS</h2>
                    </div>
                    {/* AJOUTE UN PETIT MARGIN POUR VERSION */}
                  </Row>

                  {/* Nouvelle présentation stylisée des versions */}
            <Row className="CenterAll" style={{ gap: 0, marginBottom: 32, justifyContent: 'center' }}>
              {[{
                name: 'Version 3.1',
                details: [
                  { title: 'Générateur A', items: ['Courant : 250mA', 'Fréquences : 625Hz à 2.5Khz'] },
                  { title: 'Générateur B', items: ['Courant : 1A', 'Fréquences : 2.5KHz à 10Khz'] },
                  { title: 'Boost', items: ['Allumé : 6 minutes', 'Éteint : 12 minutes'] },
                ]
              }, {
                name: 'Version 3.2',
                details: [
                  { title: 'Générateur A', items: ['Courant : 500mA', 'Fréquences : 625Hz à 2.5Khz'] },
                  { title: 'Générateur B', items: ['Courant : 1A', 'Fréquences : 2.5KHz à 10Khz'] },
                  { title: 'Boost', items: ['Allumé : 6 minutes', 'Éteint : 12 minutes'] },
                ]
              }, {
                name: 'Version 3.3',
                details: [
                  { title: 'Générateur A', items: ['Courant : 1A', 'Fréquences : 625Hz à 2.5Khz'] },
                  { title: 'Générateur B', items: ['Courant : 1A', 'Fréquences : 2.5KHz à 10Khz'] },
                  { title: 'Boost', items: ['Pas de boost possible'] },
                ]
              }, {
                name: 'Version 3.4',
                details: [
                  { title: 'Générateur A', items: ['Courant : 2A', 'Fréquences : 625Hz à 2.5Khz'] },
                  { title: 'Générateur B', items: ['Courant : 1A', 'Fréquences : 2.5KHz à 10Khz'] },
                  { title: 'Boost', items: ['Allumé : 6 minutes', 'Éteint : 12 minutes'] },
                ]
              }, {
                name: 'Version 3.5',
                details: [
                  { title: 'Générateur A', items: ['Courant : 4A', 'Fréquences : 625Hz à 2.5Khz'] },
                  { title: 'Générateur B', items: ['Courant : 1A', 'Fréquences : 2.5KHz à 10Khz'] },
                  { title: 'Boost', items: ['Pas de boost possible'] },
                ]
              }, {
                name: 'Version 4.1',
                details: [
                  { title: 'Générateur A', items: ['Courant : 500mA', 'Fréquences : 625Hz à 2.5Khz'] },
                  { title: 'Générateur B', items: ['Courant : 1A', 'Fréquences : 2.5KHz à 10Khz'] },
                  { title: 'Boost', items: ['Allumé : 6 minutes', 'Éteint : 12 minutes'] },
                ]
              }, {
                name: 'Version 4.2',
                details: [
                  { title: 'Générateur A', items: ['Courant : 1A', 'Fréquences : 625Hz à 2.5Khz'] },
                  { title: 'Générateur B', items: ['Courant : 1A', 'Fréquences : 2.5KHz à 10Khz'] },
                  { title: 'Boost', items: ['Allumé : 6 minutes', 'Éteint : 12 minutes'] },
                ]
              }, {
                name: 'Version 4.3',
                details: [
                  { title: 'Générateur A', items: ['Courant : 2A', 'Fréquences : 625Hz à 2.5Khz'] },
                  { title: 'Générateur B', items: ['Courant : 1A', 'Fréquences : 2.5KHz à 10Khz'] },
                  { title: 'Boost', items: ['Allumé : 6 minutes', 'Éteint : 12 minutes'] },
                ]
              }, {
                name: 'Version 4.4',
                details: [
                  { title: 'Générateur A', items: ['Courant : 4A', 'Fréquences : 625Hz à 2.5Khz'] },
                  { title: 'Générateur B', items: ['Courant : 1A', 'Fréquences : 2.5KHz à 10Khz'] },
                  { title: 'Boost', items: ['Allumé : 6 minutes', 'Éteint : 12 minutes'] },
                ]
              }, {
                name: 'Version 4.5',
                details: [
                  { title: 'Générateur A', items: ['Courant : 8A', 'Fréquences : 625Hz à 2.5Khz'] },
                  { title: 'Générateur B', items: ['Courant : 1A', 'Fréquences : 2.5KHz à 10Khz'] },
                  { title: 'Boost', items: ['Pas de boost possible'] },
                ]
              }].map((version, idx) => (
                <Col
                  key={version.name}
                  xs={12}
                  sm={10}
                  md={6}
                  lg={4}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: 32,
                  }}
                >
                  <Card
                    className="version-card-custom"
                    style={{
                      width: '100%',
                      maxWidth: 370,
                      minHeight: 220,
                      background: '#fff',
                      borderRadius: 18,
                      boxShadow: '0 2px 12px 0 rgba(0,0,0,0.08)',
                      padding: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <CardHeader
                      className="version-header-custom"
                      style={{
                        background: 'linear-gradient(90deg, #e3f0ff 0%, #f8faff 100%)',
                        borderTopLeftRadius: 18,
                        borderTopRightRadius: 18,
                        padding: '18px 20px 10px 20px',
                        borderBottom: 'none',
                        minHeight: 0,
                      }}
                    >
                      <h5 style={{ margin: 0, fontWeight: 700, fontSize: 20, color: '#1a237e', letterSpacing: 0.5 }}>{version.name}</h5>
                    </CardHeader>
                    <CardBody style={{ padding: '18px 20px 10px 20px' }}>
                      {version.details.map((block, i) => (
                        <div key={block.title + i} style={{ marginBottom: 10 }}>
                          <strong style={{ color: '#0d47a1', fontSize: 15 }}>{block.title} :</strong>
                          <ul className="custom-reglages-dot" style={{ marginBottom: 0, marginTop: 4, paddingLeft: 18 }}>
                            {block.items.map((item, j) => (
                              <li key={j} style={{ fontSize: 14, color: '#333', marginBottom: 2 }}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row> 
          </Col>
        </div>
      </div>
    </>
  );
}
